// extracted by mini-css-extract-plugin
export var dropdownButton = "_21-0";
export var fullWidthDropdownButton = "_21-1";
export var icon = "_21-3";
export var iconPlaceholder = "_21-2";
export var menuItemRow = "_21-5";
export var shortcutContainer = "_21-4";